export default props => [
  {
    propAddValue: 'showChatBot',
    id: 'ze-snippet',
    src:
      'https://static.zdassets.com/ekr/snippet.js?key=aac69570-a454-4484-b769-02d662a1bea9',
    defer: true,
  },
  {
    src: 'https://www.googletagmanager.com/gtag/js?id=<%=googleFloodlightsId%>',
    defer: true,
  },
  {
    type: 'text/javascript',
    src: 'https://js.adsrvr.org/up_loader.1.1.0.js',
    defer: true,
  },
  {
    propAddValue: 'showChatBot',
    type: 'text/javascript',
    innerHTML: `
      try {
        window.zESettings = {
          webWidget: {
            color: {
              theme: '#0e497b',
              launcher: '#1570bc', // This will also update the badge
              button: '#1570bc',
              resultLists: '#0e497b',
              header: '#0e497b',
              articleLinks: '#1570bc',
            },
            launcher: {
              label: {
                'en-US': 'Ask NM',
              },
            },
            answerBot: {
              avatar: {
                url: '<%=basePath%>/template/assets/<%=nmxTemplateVersion%>/images/chat-logo-v3.png',
                name: {
                  '*': 'Northwestern Mutual',
                },
              },
              title: {
                '*': "I'm the NM Answer Bot.",
              },
            },
            helpCenter: {
              originalArticleButton: false,
            }, 
          },
        };
      } catch (err) {
        console.error('Chatbot failed to load with error: ' + err);
      }
    `,
    defer: true,
  },
  {
    propAddValue: 'floodlightSendTo',
    innerHTML: `
      try {
        gtag('event', 'conversion', {
          allow_custom_scripts: true,
          send_to: '<%=googleFloodlightsId%>/${props.floodlightSendTo}',
        });
      } catch (err) {
        console.error('Google floodlights pixel failed to load with error: ' + err);
      }
    `,
    defer: true,
  },
  {
    type: 'text/javascript',
    innerHTML: `
      try {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', '<%=googleAdWordsId%>'); // Google Ads
        gtag('config', '<%=googleAnalyticsTrackingId%>'); // Google Analytics
        gtag('config', '<%=googleFloodlightsId%>'); // Floodlight Ads
      } catch (err) {
        console.error('Google pixels failed to load with error: ' + err);
      }
    `,
    defer: true,
  },
  /*
  ==========
  Start Universal pixels
  ==========
  */
  {
    /* BING PIXEL */
    propAddValue: 'showBingPixel',
    type: 'text/javascript',
    defer: true,
    innerHTML: `
      try {
        (function (w, d, t, r, u) {
          let f;

          let n;

          let i;
          (w[u] = w[u] || []),
          (f = function () {
            const o = { ti: '5564967' };
            (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange = function () {
            const s = this.readyState;
            (s && s !== 'loaded' && s !== 'complete')
                || (f(), (n.onload = n.onreadystatechange = null));
          }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i);
        }(window, document, 'script', '//bat.bing.com/bat.js', 'uetq'));
      } catch (err) {
        console.error('Bing pixel failed to load with error: ' + err);
      }
    `,
  },
  {
    /* FACEBOOK PIXEL */
    propAddValue: 'showFacebookPixel',
    type: 'text/javascript',
    defer: true,
    innerHTML: `
      try {
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(
          window,
          document,
          'script',
          'https://connect.facebook.net/en_US/fbevents.js',
        ));
        // We made the determination that we don't have to implement LDU to fall under the service provider
        // definition because the event information we send does not constitute personal information.
        //
        // So, we're still compliant under the terms of CCPA without implementing LDU.
        //
        // Implementing LDU would mean creating a data gap AND sending users' IP information to Facebook
        // when we didn't before.
        fbq('dataProcessingOptions', []);
        fbq('init', '287689728264317');
        fbq('track', 'PageView');
      } catch (err) {
        console.error('Facebook pixel failed to load with error: ' + err);
      }
    `,
  },
  {
    /* PINTEREST PIXEL */
    propAddValue: 'showPinterestPixel',
    type: 'text/javascript',
    defer: true,
    innerHTML: `
      try {
        !(function (e) {
          if (!window.pintrk) {
            window.pintrk = function () {
              window.pintrk.queue.push(Array.prototype.slice.call(arguments));
            };
            const n = window.pintrk;
            (n.queue = []), (n.version = '3.0');
            const t = document.createElement('script');
            (t.async = !0), (t.src = e);
            const r = document.getElementsByTagName('script')[0];
            r.parentNode.insertBefore(t, r);
          }
        }('https://s.pinimg.com/ct/core.js'));
        pintrk('load', '2615053361842');
        pintrk('page');
      } catch (err) {
        console.error('Pinterest pixel failed to load with error: ' + err);
      }
    `,
  },
  {
    /* GOOGLE PLACES  */
    propAddValue: 'showGooglePlaces',
    type: 'text/javascript',
    defer: true,
    src:
      'https://maps.googleapis.com/maps/api/js?key=<%=googlePlacesApiKey%>&amp;libraries=geometry,places',
  },
  {
    /* TWITTER PIXEL */
    type: 'text/javascript',
    defer: true,
    innerHTML: `
      try {
        !(function (e, t, n, s, u, a) {
          e.twq
            || ((s = e.twq = function () {
              s.exe ? s.exe(...arguments) : s.queue.push(arguments);
            }),
            (s.version = '1.1'),
            (s.queue = []),
            (u = t.createElement(n)),
            (u.async = !0),
            (u.src = '//static.ads-twitter.com/uwt.js'),
            (a = t.getElementsByTagName(n)[0]),
            a.parentNode.insertBefore(u, a));
        }(window, document, 'script'));
        // Insert Twitter Pixel ID and Standard Event data below
        twq('init', 'nvpap');
        twq('track', 'PageView');
      } catch (err) {
        console.error('Twitter pixel failed to load with error: ' + err);
      }
    `,
  },
  {
    type: 'text/javascript',
    defer: true,
    innerHTML: `
      // TODO without the timeout ttd_dom_ready is sometimes not loaded/ready yet to call, not sure why
      try {
        setTimeout(() => {
          ttd_dom_ready(() => {
            if (typeof TTDUniversalPixelApi === 'function') {
              const universalPixelApi = new TTDUniversalPixelApi();
              universalPixelApi.init(
                'aiovgq0',
                ['z8ds8vu'],
                'https://insight.adsrvr.org/track/up',
              );
            }
          });
        }, 500);
      } catch (err) {
        console.error('TTD Universal MiQ pixel failed to load with error: ' + err);
      }
    `,
  },
  /*
  ==========
  END Universal pixels
  ==========
  */
];
